import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { Card, CardHeader } from '../ui/Card';
import type { TwinsPerUser } from '../../types';

interface TwinsChartProps {
  data: TwinsPerUser[];
}

export function TwinsChart({ data }: TwinsChartProps) {
  // Take top 10 users with most twins
  const chartData = data.slice(0, 10).map((item) => ({
    name: item.userName.split(' ')[0],
    twins: item.twinCount,
  }));

  return (
    <Card className="h-[400px]">
      <CardHeader
        title="Twins per User"
        subtitle="Top 10 users with most twins created"
      />
      
      <div className="h-[300px] mt-4">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#2a2a3a" vertical={false} />
            <XAxis
              dataKey="name"
              stroke="#64748b"
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              stroke="#64748b"
              fontSize={12}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: '#1a1a24',
                border: '1px solid #2a2a3a',
                borderRadius: '8px',
              }}
              labelStyle={{ color: '#f8fafc' }}
              itemStyle={{ color: '#3b82f6' }}
              cursor={{ fill: '#2a2a3a' }}
            />
            <Bar
              dataKey="twins"
              fill="#3b82f6"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
